import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import TextField from "@mui/material/TextField";
import { Formik } from "formik";
import { Grid, Typography, Card, TableContainer, Table, TableRow, TableCell, TableBody, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import { makeStyles } from "@mui/styles";
import AddIcon from "@mui/icons-material/Add";

const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function AddFreightTerms() {
  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [MasterCost, setMasterCost] = useState([])

  function addRow() {
    const newRow = {
      id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
      CostId: "",
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {

    const data = rows?.filter((e, id) => i !== id);
    setRows(data);
  };
  useEffect(() => {
    const getMasterCost = async () => {
      try {
        const res = await api.get(`/api/master/cost/Sale%20Order%20Cost`);
        setMasterCost(res?.data);

        //   setLog_data_length(3);
      } catch (e) {
        console.log(e);
      }
    };
    getMasterCost()
  },[])
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          เงื่อนไขการขนส่งสินค้า
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Freight Terms
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Setting</Typography>
            <Typography>
              <span>&nbsp;</span> / FreightTerms
            </Typography>
          </Grid>
        </Grid>

        <Formik
          initialValues={{ f_t_name: "", f_t_no: "" }}
          validate={(values) => {
            const errors = {};
            if (!values.f_t_name || values.f_t_name === "") {
              errors.f_t_name = " * Required";
            }
            if (!values.f_t_no || values.f_t_no === "") {
              errors.f_t_no = " *  Required";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              const data = {
                no: values.f_t_no,
                name: values.f_t_name,
                status: 1,
                createId: EmpId,
              };

              api
                .post("api/terms/create", data)
                .then((respose) => {
                  const MySwal = withReactContent(Swal);

                  MySwal.fire({
                    icon: "success",
                    didOpen: () => {
                      MySwal.clickConfirm();
                    },
                  }).then(() => {
                    return MySwal.fire(
                      "สำเร็จ!",
                      "เพิ่มข้อมูลเงื่อนไขการขนส่งสินค้าสำเร็จ !",
                      "success"
                    ).then((result) => {
                      if (result.isConfirmed) {
                        history.push("/Setting/FreightTerms");
                      }
                    });
                  });
                })
                .catch((err) => {
                  console.log(err);
                });

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <h6 style={{ marginTop: "10px" }} className="textcolordarkblue">
                เพิ่มเงื่อนไขการขนส่งสินค้า
              </h6>
              <Grid container>
                <Grid item xs={4} sm={3} md>
                  <TextField
                    name="f_t_name"
                    label="FREIGHT TERMS"
                    variant="outlined"
                    placeholder="FREIGHT TERMS"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ width: "50%" }}
                    InputLabelProps={{ shrink: true }}
                    value={values.f_t_name}
                    classes={{ root: !values.f_t_name ? classes.customOutline : null }}
                    required
                  />
                  {/* {errors.f_t_name && touched.f_t_name && errors.f_t_name} */}
                  <br />
                  <TextField
                    label="FREIGHT TERMS NO."
                    InputLabelProps={{ shrink: true }}
                    placeholder="Enter FREIGHT TERMS NO."
                    name="f_t_no"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                      marginBottom: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.f_t_no}
                    classes={{ root: !values.f_t_no ? classes.customOutline : null }}
                    required
                  />
                  {/* {errors.f_t_no && touched.f_t_no && errors.f_t_no} */}
                </Grid>
              </Grid>
              <Button
                type="button"
                variant="contained"
                // disabled={costType ? false : true}
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginTop: "10px",
                }}
                onClick={addRow}
              >
                <AddIcon /> Add
              </Button>
              <TableContainer sx={{ marginTop: 2, marginBottom: 2 }}>
                <Table stickyHeader>
                  <TableRow>
                    <TableCell align="center" width="5%">#</TableCell>
                    <TableCell align="center" width="15%">Cost</TableCell>


                    {/* <TableCell align="center" width="15%">TaxTotal</TableCell> */}
                    <TableCell align="center" width="10%"></TableCell>
                  </TableRow>
                  {rows?.map((data, index) => {
                    return (
                      <TableBody key={index}>
                        <TableCell align="center">{index + 1}</TableCell>
                        <TableCell align="center">
                          <FormControl fullWidth>
                            <InputLabel>Cost</InputLabel>
                            <Select
                              label="Charge"
                              value={data?.CostId || ''}
                              InputLabelProps={{ shrink: true }}
                              onChange={(e) => {
                                const io = rows?.map((v) => {
                                  v.CostId =
                                    v?.id === data?.id ? e.target.value : v?.CostId;
                               
                                  return v;
                                });

                                setRows([...io]);
                              }}
                            >
                              {MasterCost?.map((x) =>
                                <MenuItem value={x?.CostId}>{x?.CostName}</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                        </TableCell>


                        <TableCell align="center">
                          <Button
                            type="button"
                            variant="outlined"
                            style={{
                              color: "#80c340",
                              borderColor: "#80c340",
                            }}
                            onClick={() => deletehand(index)}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      </TableBody>
                    );
                  })}

                </Table>
              </TableContainer>
              <Button
                type="button"
                variant="outlined"
                style={{
                  color: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                onClick={history.goBack}
              >
                back
              </Button>
              <Button
                type="submit"
                variant="contained"
                style={{
                  background: "#80c340",
                  borderColor: "#80c340",
                  marginRight: "10px",
                }}
                disabled={isSubmitting}
              >
                {isSubmitting && <CircularProgress size={22} />}
                {!isSubmitting && "SAVE"}
              </Button>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
